module.exports = __webpack_public_path__ + "img/ok-icon1-1.fa5232d4.png";